export default __webpack_public_path__ + "static/N0245-1e4744677052ae033344852949525846.png";